'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import {Button} from '../../../components/buttons/Button';
import {I18nMessage} from '../../../components/I18nMessage';
import {ProjectLayout} from '../../../components/views/ProjectLayout';
import {PeopleList} from '../PeopleList';
import {PersonnelViewOverviewFilter} from './PersonnelViewOverviewFilter';


export function PersonnelViewOverviewView(props) {
  return (
    <ProjectLayout
      className={classNames("PersonnelViewOverview", props.className)}
      title={<I18nMessage message="personnel.home.header.label" />}
      showBackButton={false}
      breadcrumbPath={props.breadcrumbPath}
      filterComponent={(
        <PersonnelViewOverviewFilter parentId={props.parentId} />
      )}
      headerRightContent={(
        <Fragment>
          <Button
            className="PersonnelViewOverview__headerButton"
            iconClass="context-icon"
            onClick={props.onClickOptions}
          />
        </Fragment>
      )}
      navBarContent={null}
      bannerContent={null}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
    >
      <PeopleList
        transitionGroupClass="ProjectLayout__content__container"
        itemClassName="ProjectLayout__content__item"
        list={props.list}
        useTypeHeaders={true}
        useSimple={false}
        useSelection={false}
        useScroll={false}
        mode={props.mode}
        onLoadMore={props.onLoadMore}
        userId={props.userId}
        parentId={props.parentId}
        collection={props.collection}
        onClickItem={props.onClickItem}
        onItemContextMenu={props.onItemContextMenu}

        init={props.init}
      />
    </ProjectLayout>
  );
}

PersonnelViewOverviewView.propTypes = {
  className: T.string,

  init: T.bool,
};

PersonnelViewOverviewView.defaultProps = {
  init: true,
};



// WEBPACK FOOTER //
// ./src/js/personnel/components/PersonnelViewOverview/PersonnelViewOverviewView.js